import { Modal } from "@smart/itops-sb-design-system-dom";

export type IntakePrintUnavailableProps = {
  text: string;
  open: boolean;
  onClose: () => void;
};

export const IntakePrintUnavailable = ({
  text,
  open,
  onClose,
}: IntakePrintUnavailableProps) => (
  <Modal
    open={open}
    onClose={onClose}
    header={{
      text: "Can not save copy of form",
      icon: "regularCircleExclamation",
    }}
    footer={{
      buttons: [{ text: "Ok", onClick: onClose }],
    }}
  >
    <p>{text}</p>
  </Modal>
);
